import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import logo from "../../../../assets/images/karak_logo_new.png";
import {
  convertToLowestUnit,
  ExportAvailableInCSVForReports,
  exportFromula,
  formatUnitsForReport,
  GetUpdatedDelivered,
  mapUnits,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";

const ProductsPOCostingReport = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedBranch, setSelectedBranch] = useState({});
  const [grandTotal, setGrandTotal] = useState(0);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [isLoadingPurchaseDetails, setIsLoadingPurchaseDetails] =
    useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const searchSigRef = useRef("");

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  function afterSearch(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0,
    );
    const sig = `${newResult.length}:${Number(total.toFixed(2))}`;
    setFilteredOrders((prevOrders) => {
      if (searchSigRef.current === sig) return prevOrders;
      searchSigRef.current = sig;
      return newResult;
    });

    setGrandTotal(Number(total.toFixed(2)));
  }

  function afterFilterForDetails(newData, quantityField) {
    const data = newData;
    let totalCost = 0;
    let totalLowestUnitQty = 0;

    data.forEach((item) => {
      const details = item;
      const { receiving_cost = 0, unit_levels, receive } = details || {};

      totalCost += Number(receiving_cost || 0);

      if (unit_levels) {
        const quantityToBeDisplayed = receive;

        if (quantityToBeDisplayed) {
          const convertedQty = convertToLowestUnit(
            unit_levels,
            quantityToBeDisplayed,
          );
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      }
    });
    let displayQuantity = "";
    const firstItemDetails = data[0];
    if (firstItemDetails?.unit_levels) {
      const { unit_levels } = firstItemDetails;
      const lowestUnit = unit_levels.at(-1).unit;

      const summedQuantity = [
        {
          unit: lowestUnit,
          value: totalLowestUnitQty,
        },
      ];

      displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
    }
    setFilterModalTotalQty(displayQuantity);
    setFilterModalSubTotal(totalCost.toFixed(2));
  }

  const [allOrders, setAllOrders] = useState([]);

  const loadOrders = async () => {
    if (!dateFrom || !dateTo) return;
    const requestId = ++ordersRequestId.current;
    try {
      setIsLoadingOrders(true);
      let url = process.env.REACT_APP_BASEURL + "productpurchaseorders/costing";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
        summary_only: true,
      });
      if (requestId !== ordersRequestId.current) return;
      if (response && response.status === 1) {
        const kitchen =
          (response.data &&
            response.data.branches &&
            response.data.branches[0]) ||
          {};
        const products = kitchen.item_details || [];
        setSelectedBranch({
          name: kitchen.name,
          branches: [{ _id: kitchen._id, name: kitchen.name }],
        });
        setAllOrders(mergeDuplicateItems(products));
        setTablePage(1);
        setGrandTotal(
          response.data?.grand_total_cost?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
        );
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      showNotification(error, "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };
  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (allOrders.length > 0) {
      if (orderStatus === "All") {
        setFilteredOrders([...allOrders]);
      } else {
        let arr = allOrders.filter((order) => order.status === orderStatus);
        setFilteredOrders(arr);
      }
    }
  }, [allOrders, orderStatus]);

  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [purchaseDetails, setPurchaseDetails] = useState([]);

  const loadPurchaseDetails = async (row) => {
    try {
      setIsLoadingPurchaseDetails(true);
      setPurchaseDetails([]);
      setPurchaseDetailsModal(true);
      const url =
        process.env.REACT_APP_BASEURL + "productpurchaseorders/costing";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
        product_id: row.product_id,
      });
      const kitchen =
        (response &&
          response.data &&
          response.data.branches &&
          response.data.branches[0]) ||
        {};
      let products = kitchen.item_details || [];
      if (row.product_id) {
        products = products.filter(
          (item) => item.product_id === row.product_id,
        );
      }
      let totalReceivingCost = 0;
      let totalLowestUnitQty = 0;

      products.forEach((item) => {
        const { receiving_cost = 0, unit_levels, receive } = item || {};

        totalReceivingCost += Number(receiving_cost);

        if (unit_levels && receive) {
          const convertedQty = convertToLowestUnit(unit_levels, receive);
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      });

      let displayQuantity = "";
      const firstDeliveryDetails = products[0] || {};
      if (firstDeliveryDetails.unit_levels) {
        const { unit_levels } = firstDeliveryDetails;
        const lowestUnit = unit_levels.at(-1).unit;
        const summedQuantity = [
          {
            unit: lowestUnit,
            value: totalLowestUnitQty,
          },
        ];
        displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
      }
      setFilterModalSubTotal(totalReceivingCost.toFixed(2));
      setFilterModalTotalQty(displayQuantity);
      setPurchaseDetails(products);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingPurchaseDetails(false);
    }
  };

  // console.log(allOrders,"all");

  function mergeDuplicateItems(items) {
    if (!items?.length) return [];

    return Object.values(
      items.reduce((acc, item) => {
        if (!acc[item.product_id]) {
          acc[item.product_id] = { ...item, is_free: item.is_free || false };
        } else {
          // Convert both quantities to lowest unit and sum them
          const convertedQty = convertToLowestUnit(
            item.unit_levels,
            item.receive,
          );
          const existingQty = convertToLowestUnit(
            acc[item.product_id].unit_levels,
            acc[item.product_id].receive,
          );
          const lowestUnit = item.unit_levels.at(-1).unit;

          const summedQuantity = [
            { unit: lowestUnit, value: Number(convertedQty + existingQty) },
          ];

          acc[item.product_id].receive = GetUpdatedDelivered(
            summedQuantity,
            item.unit_levels,
          );
          acc[item.product_id].receiving_cost += Number(item.receiving_cost);
          acc[item.product_id].is_free =
            acc[item.product_id].is_free || item.is_free;
        }
        return acc;
      }, {}),
    );
  }

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadPurchaseDetails(row);
            }}
          >
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "receive",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return <>{formatUnitsForReport(row.receive)}</>;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Purchasing Unit"),
      dataField: "unit_for_cost_price",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell,row)=>{
    //     // return row?.price + "/" + row?.unit_for_cost_price
    //     return row?.price
    //    },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "receiving_date",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.receiving_date).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const columnsPurchaseDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.receive);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "is_free",
      text: props.t("Free ?"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "unit_for_cost_price",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.cost_price + "/" + row?..unit_for_cost_price
      //  },
      formatter: (cell, row) => {
        if (row?.is_free) {
          return row?.free_cost_price;
        } else {
          return row?.price;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row.is_free) {
          return (
            <div>
              <div>Projected: {row?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_date",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return row?.receiving_date
          ? moment(row.receiving_date).format("DD/MM/YYYY HH:mm")
          : " ";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "PO_costing_report_products";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          Formula: v.unit_levels && exportFromula(v.unit_levels),
          Purchasing_Unit: v.unit_for_cost_price,
          Total_Cost: v.receiving_cost,
          Total_Quantity: ExportAvailableInCSVForReports(v.receive),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("PO Costing Report - Products")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("PO Costing Report - Products")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("PO Costing Report (Products)")} <br />
                      <h6>(PO Costing Report : Products PO created by CKM )</h6>
                    </CardTitle>
                    <ToolkitProvider
                      keyField="product_id"
                      data={allOrders && allOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(propss) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...propss.searchProps}
                                style={{ width: "300px" }}
                                delay={500}
                                onSearch={(searchText) => {
                                  if (!searchText || searchText.trim() === "") {
                                    propss.searchProps.onSearch(searchText);
                                    afterSearch(propss.baseProps.data);
                                    return;
                                  }
                                  if (searchText?.length <= 3) return;
                                  const searchResult =
                                    propss.baseProps.data?.filter((row) => {
                                      const matchesSearch = (value) => {
                                        if (
                                          value === null ||
                                          value === undefined
                                        )
                                          return false;
                                        if (typeof value === "object") {
                                          return Object.values(value).some(
                                            (v) => matchesSearch(v),
                                          );
                                        }
                                        return String(value)
                                          .toLowerCase()
                                          .includes(searchText.toLowerCase());
                                      };
                                      return Object.values(row).some(
                                        matchesSearch,
                                      );
                                    });

                                  propss.searchProps.onSearch(searchText);
                                  afterSearch(searchResult);
                                }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col
                              lg={4}
                              style={
                                {
                                  // display: "flex",
                                  // alignItems: "flex-end",
                                  // padding: "8px"
                                }
                              }
                            >
                              <h5>
                                Grand Total : QR{" "}
                                {grandTotal.toLocaleString("en-QA", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            filter={filterFactory({ afterSearch })}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...propss.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivPurchaseitem">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("PO Costing Details")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>

                  <CardTitle className="text-center">
                    {props.t("(Purchase Product Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Store:{" "}
                                {(selectedBranch?.branches?.length &&
                                  selectedBranch?.branches[0]?.name) ||
                                  selectedBranch?.name ||
                                  ""}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={purchaseDetails && purchaseDetails}
                            columns={columnsPurchaseDetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "receive",
                                    "",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            condensed
                            noDataIndication={
                              isLoadingPurchaseDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ProductsPOCostingReport)),
);
